import React, { useState,useEffect } from 'react';
import {
  Box,
  TextField,
  Grid,
  Button,
  MenuItem,
  Typography,
  Autocomplete
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { legalTeamApi } from '../../api/api';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { investorApi } from '../../api/api';

const UpdateSaleByTeam = () => {
  const location=useLocation();
  const {saledata}=location.state;
  const navigate = useNavigate();
  const [users,setUsers]=useState([]);
  const [snackbar,setSnackbar] = useState({
    open:false,
    message:"",
    severity:"success"
  })

  const handleSnackbarClose=()=>{
    setSnackbar({...snackbar,open:false})
  }
 useEffect(() => {
    const fetchData = async () => {
      try {
        const  usersRes = await  investorApi.getAllUsers();
        setUsers(
          usersRes.data.map((item) => ({
            id: item.ID,
            username: item.Username,
            mobilenumber:item.Mobilenumber
          }))
        );

      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    };

    fetchData();
  }, []);
  // Dummy initial values – replace with real data or props
  const [form, setForm] = useState({
    userId:"",
    SalePrice: '',
    Status: 'InProgress',
    SaleDate: "", 
  });

  const statuses = [ 'InProgress', 'Completed', 'Rejected'];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async() => {
    try{
      const response= await legalTeamApi.updateSaleByTeam({
        userId:form.userId,
        PropertyType:saledata.PropertyType,
        propertyId:saledata.propertyId,
        salePrice:form.SalePrice,
        status:form.Status,
        saleDate:form.SaleDate
      });
      
      setSnackbar({
        open:true,
        message:"Sale updated successfully",
        severity:"success"
      });
    }
    catch(error){
      
      setSnackbar({
        open:true,
        message:"failed to update sale",
        severity:'error'
      });
    }
  };

  const handleCancel = () => {
    navigate(-1); // go back
  };

  return (
    <Box sx={{ height: "100vh", width: "100%", p: 4 }}>
      <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold' }}>Update Sale</Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Property Name"
            name="PropertyName"
            value={saledata.PropertyName}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
         <Autocomplete
             options={[{ id: '0', username: 'N/A' }, ...users]}
             getOptionLabel={(option) => `${option.username} - ${option.mobilenumber}`}
             value={users.find((user) => user.id === form.userId) }
             onChange={(event, newValue) => {
               handleChange({
                 target: {
                   name: 'userId',
                   value: newValue ? newValue.id : '',
                 },
               });
             }}
             renderInput={(params) => (
               <TextField
                 {...params}
                 label="User Name"
                 name="userId"
                 fullWidth
                 required
               />
             )}
             isOptionEqualToValue={(option, value) => option.id === value.id}
           />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Sale Price"
            name="SalePrice"
            value={form.SalePrice}
            onChange={handleChange}
            type="number"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            select
            fullWidth
            label="Status"
            name="Status"
            value={form.Status}
            onChange={handleChange}
          >
            {statuses.map((status) => (
              <MenuItem key={status} value={status}>
                {status}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
                          label="Sale Date"
                          type="date"
                          name="SaleDate"
                          value={form.SaleDate}
                          onChange={handleChange}
                          fullWidth
                          required
                          InputLabelProps={{ shrink: true }}
                          inputProps={{
    max: new Date().toISOString().split("T")[0], 
  }}
            />
        </Grid>
        <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleUpdate}
            sx={{ mr: 2 }}
          >
            Update
          </Button>
          <Button variant="outlined" color="secondary" onClick={handleCancel}>
            Cancel
          </Button>
        </Grid>
      </Grid>
      <Snackbar
      open={snackbar.open}
      autoHideDuration={3000}
      onClose={handleSnackbarClose}
      anchroOrigin={{vertical:"bottom",horizantal:"left"}}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{width:"100%"}}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default UpdateSaleByTeam;
